module.exports = __webpack_public_path__ + "static/media/dts.6b0937a3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/dts.gif
// module id = 118
// module chunks = 0